import type { Point } from '../../types/diagram.tsx';

// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
export enum Axis {
	/** Horizontal axis spanning left and right */
	x = 'x',
	/** Vertical axis spanning top and bottom */
	y = 'y',
}

// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
export enum Direction {
	/** Points ↑ indicating negative Y value */
	up = 'up',
	/** Points ↓ indicating positive Y value */
	down = 'down',
	/** Points ← indicating negative X value */
	left = 'left',
	/** Points → indicating positive X value */
	right = 'right',
}

export type Vector = Point & {
	direction: Direction;
};

/** Extract only x and y fields from an object that includes those fields (e.g. Vector) */
export const extractPoint = <TPoint extends Point>({ x, y }: TPoint): Point => ({ x, y });

export const axisOf = (vector: Vector): Axis => {
	switch (vector.direction) {
		case Direction.up:
			return Axis.y;
		case Direction.down:
			return Axis.y;
		case Direction.left:
			return Axis.x;
		default: // right
			return Axis.x;
	}
};
